// src/pages/Wallet/components/WalletHeader.js
import React, { useState, useContext } from 'react';
import { WalletContext } from '../../../contexts/WalletContext';
import { NetworkContext } from '../../../contexts/NetworkContext';
import { AiOutlineCopy, AiOutlineCheck } from 'react-icons/ai';
import myWalletLogo from '../../../assets/wallet-logo.png';
import chainLogos from '../chainLogos';

const WalletHeader = ({ onOpenNetworkModal, onOpenWalletModal }) => {
  const { currentWallet, address } = useContext(WalletContext);
  const { currentChain } = useContext(NetworkContext);
  const [copied, setCopied] = useState(false);
  const copyTimeout = 2000; // 2 seconds
  
  // Handle copy address to clipboard
  const handleCopyAddress = (addr) => {
    navigator.clipboard.writeText(addr);
    setCopied(true);
    setTimeout(() => setCopied(false), copyTimeout);
  };
  
  // Get current chain logo
  const chainKeyValue = currentChain?.key || "ethereum";
  const chainLogo = chainLogos[chainKeyValue];
  
  return (
    <div className="wallet-header">
      <div className="header-left-wallet">
        <a href="https://bit-dog.com/" target="_blank" rel="noopener noreferrer">
          <img src={myWalletLogo} alt="Wallet Logo" className="wallet-logo" />
        </a>
      </div>
      <div className="header-center" onClick={onOpenWalletModal}>
        <div className="account-name">
          {currentWallet?.name || "Account 1"}
        </div>
        <div className="account-address">
          {address ? address.slice(0, 6) + "..." + address.slice(-4) : "No Wallet"}
          {address && (
            copied ? (
              <AiOutlineCheck className="copy-icon" />
            ) : (
              <AiOutlineCopy
                className="copy-icon"
                onClick={(e) => {
                  e.stopPropagation();
                  handleCopyAddress(address);
                }}
              />
            )
          )}
        </div>
      </div>
      <div className="header-right-wallet" onClick={onOpenNetworkModal}>
        <img src={chainLogo} alt={currentChain?.name || "Network"} className="network-logo-wallet" />
      </div>
    </div>
  );
};

export default WalletHeader;